// extracted by mini-css-extract-plugin
export default {"dot-spinner":"loader_dot-spinner__GXvbw","dot-spinner__dot":"loader_dot-spinner__dot__uwOcm","pulse0112":"loader_pulse0112__+pE8a"};